import {  Modal,Text, useMantineTheme } from "@mantine/core";
import { Box } from "@mui/material";

import React from "react";
import { ConfirmationPopUpProps } from "../../types/types";
import RenderSvg from "../renderSvg/RenderSvg";


import "./confirmationPopUp.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

export function ConfirmationPopUp(props: ConfirmationPopUpProps) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const theme = useMantineTheme();
  const closeModal = () => {
    props.setOpenConfirmModal(false);
  };
  const rejectMethod = () => {
    props.rejectMethod && props.rejectMethod();
    closeModal();
  };
  const successMethod = () => {
    props.successMethod();
    closeModal();
  };
  return (
    <Modal
      centered
      withCloseButton={false}
      overlayColor={
        theme.colorScheme === "dark"
          ? theme.colors.dark[9]
          : theme.colors.gray[2]
      }
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={props.openConfirmModal}
      onClose={closeModal}
      radius="lg"
      size="500px"
      className="confirmationPopUp-modalContainer"
    >
      <div className="confirmationPopUp-container">
        <Box>
          <Box
            sx={() => ({
              display: "flex",
              justifyContent: "center",
              margin:"10px"
            })}
          >
            <RenderSvg name="QuestionMark" />
          </Box>
          <Text
              size="xl"
              align="center"
              sx={() => ({
                width: "100%",
                justifyContent: "center",
                marginBottom: "6%",
                marginTop: "6%",
                fontSize: "16px",
                paddingLeft: "3rem",
                paddingRight: "3rem",
              })}
            >
                 {translate(TranslationEnum.common_portal,props.message)}
            </Text>
        </Box>
         {props.confirmationCustomComponent}
        <div className="reset-password-button">
          <button className="reset-button-confirmationPopup cancel-button-confirmationPopup" onClick={rejectMethod}>
          {translate(TranslationEnum.common_portal,"CANCEL")}
          </button>
          <button className="reset-button-confirmationPopup" onClick={successMethod}>
          {props?.rightButtonText ? props?.rightButtonText : translate(TranslationEnum.common_portal,"CONFIRM")}
          </button>
        </div>
      </div>
    </Modal>
  );
}
